module.exports = __webpack_public_path__ + "img/dangjian.05fde3fb.png";